<template>
  <div
    v-if="socialShare.socialShareEnabled"
    class="cac-media-icons__container"
  >
    <a
      v-for="shareOption in shareOptions"
      :key="shareOption.label"
      :aria-label="shareOption.ariaLabel"
      :href="shareOption.link"
      target="_blank"
      @click.prevent="share(shareOption)"
    >
      <icon
        :icon-name="iconNames[shareOption.label.toUpperCase()]"
        view-box="0 0 34 34"
        class="cac-media-icons-circle"
      />
    </a>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Icon from "StyleguideComponents/Icon.vue";
import * as ICON_NAMES from "Constants/styleguide/iconNames";
import STATE from "Constants/campaign/civicactioncenter/state";
import SharedMixin from "JS/mixins/campaign/civicactioncenter/shared";

export default {
  name: "SocialMediaIcons",
  components: {
    Icon
  },
  mixins: [SharedMixin],
  data() {
    return {
      iconNames: ICON_NAMES
    };
  },
  computed: {
    ...mapState(STATE.SCOPE_CAMPAIGN, [
      "previewMode",
      "socialShare",
      "shareOptions"
    ])
  },
  methods: {
    share(shareOption) {
      // do not allow sharing if user is previewing campaign
      if (this.previewMode) {
        // eslint-disable-next-line no-alert
        return alert("Cannot share from preview");
      }

      if (shareOption.authEnabled) {
        return this.openPopup(shareOption.link);
      }

      return this.openTab(shareOption.link);
    }
  }
};
</script>
